import styled from 'styled-components';
import { Button } from 'UI';

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ExtraAddButton = styled(Button)`
  flex: 1;
`;

export const SearchContainer = styled.div`
  display: flex;
  margin-right: 0.5rem;
`;

export const SwitchContainer = styled.div`
  margin-right: 0.5rem;
  margin-left: 0.5rem;
`;
